import { render } from "./MemberTeam.vue?vue&type=template&id=0d63dad4&scoped=true"
import script from "./MemberTeam.vue?vue&type=script&lang=js"
export * from "./MemberTeam.vue?vue&type=script&lang=js"

import "./MemberTeam.vue?vue&type=style&index=0&id=0d63dad4&scoped=true&lang=css"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d63dad4"]])

export default __exports__